module.exports = __webpack_public_path__ + "img/grp-part-4-corporate-2.7a2908f0.png";